export enum EventTypeEnum {
  APPOINTMENT = 'Termin',
  PLAN = 'Planeintrag',
  TICKET = 'Ticket',
  OBJECT = 'Objekt',
  TASK = 'Aufgabe',
  NEW_EVENT = 'Neuer Eintrag',
  ABSENCE = 'Abwesenheit',
  NONE = 'Keine',
}
